import { create } from 'zustand';

const useStore = create((set) => ({
    user_profile: null,
    diamond: null,
    rating: null,
    // Метод для обновления алмазов
    updateDiamond: (newValue) => set({ diamond: newValue }),
    // Метод для обновления рейтинга
    updateRating: (newValue) => set({ rating: newValue }),
    updateUserProfile: (profile) => set({ user_profile: profile }),
    // Или один метод для всех данных
    updateAllData: (profile, diamond, rating) => set({
        user_profile: profile,
        diamond: diamond,
        rating: rating
    }),
}))

export default useStore;



